import { useMutation, useQueryClient } from '@tanstack/react-query';

/* Keys & Apis */
import { cart } from '@api/apis';
import { cartQueryKeys } from './queries.keys';

/* Utils */
import { Logger } from '@utils/logger';
import { derivedPlanUpsellReferrer } from '@integrations/segment/upsell';
import { updateAppNotification } from '@store/client/store.notifications';
import { deriveResponseError, deriveResponseStatus } from '@utils/object';
import { StatusErrors } from '@constants/base';

interface ISelectPlan {
  planId: number;
  channelKey?: string;
  referer?: string;
}

const ChannelKey = {
  '1': 'plan_upsell_channel',
  '2': 'upsell_channel',
};

export default function useCartMutationSelectplan() {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async ({ planId, channelKey = '1', referer = '' }: ISelectPlan) => {
      const data = await cart.selectPlan({
        plan_id: planId,
        [(ChannelKey as Record<string, string>)[channelKey]]: referer || derivedPlanUpsellReferrer(),
      });

      if (StatusErrors.has(deriveResponseStatus(data)) || data.err) throw data;

      return data;
    },
    onSuccess: data => {
      const { cart: cartResponse = {} } = data?.data ?? {};

      queryClient.setQueryData(cartQueryKeys.all, { ...cartResponse });
    },
    /* Thrown error goes here: we can roll back if needed */
    onError: error => {
      const { errors } = deriveResponseError(error);
      updateAppNotification({ error_title: 'Sorry', errors });
      Logger('useCartMutationSelectplan')(error as Error);
    },
  });
}
